import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center h-screen w-full bg-[#050507] text-white p-6 text-center">
          <div className="max-w-md">
            <div className="w-20 h-20 bg-rose-500/10 rounded-3xl flex items-center justify-center text-rose-500 text-4xl mb-6 mx-auto shadow-2xl shadow-rose-500/20 border border-rose-500/20">
                <i className="fas fa-bug"></i>
            </div>
            <h1 className="text-2xl font-black mb-2">Something went wrong</h1>
            <p className="text-slate-400 text-sm mb-8 leading-relaxed">
              The application encountered an unexpected error. Our team has been notified. Please try refreshing the page.
            </p>
            <div className="p-4 bg-black/30 rounded-xl border border-white/5 text-left mb-8 overflow-hidden">
                <code className="text-[10px] text-rose-400 font-mono break-all block">
                    {this.state.error?.toString()}
                </code>
            </div>
            <button
              onClick={() => window.location.reload()}
              className="bg-white text-black px-8 py-3 rounded-xl font-black text-xs hover:scale-105 transition-transform"
            >
              Refresh Application
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;